import { createFileRoute } from "@tanstack/react-router";
import PartsCategories from "@/pages/PartsCategories";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/categories")({
  head: () => pageHead({ title: 'Parts Categories', description: 'Browse RV parts by category — appliances, electrical, plumbing, towing and more.', path: '/parts-catalog/categories' }),
  component: PartsCategories,
});
